import classes from "./ContactDetail.module.css";
import Card from "../UI/Card";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ContactDetail = (props) => {
  return (
    <Card color="alt">
      <div className={classes.wrapper}>
        <div className={classes.info}>
          <FontAwesomeIcon icon={props.type} size="6x" color="#0c2461" />
        </div>
        <div className={classes.data}>
          <div className={classes.data1}>{props.field1}</div>
          <div className={classes.data2}>{props.field2}</div>
          <div className={classes.data3}>{props.field3}</div>
        </div>
      </div>
    </Card>
  );
};

export default ContactDetail;
